import SectionTabs from "@/components/SectionTabs";
import { User, ImageIcon, Sparkles, Briefcase, Inbox, Sparkles as MissionIcon } from "lucide-react";

/* Reusable group tab bars used across the talent dashboard.
   Each tab is a real <Link>, no existing route is altered. */

export function ProfilTabs() {
  return (
    <SectionTabs
      eyebrow="Profil"
      title="Mon univers"
      subtitle="Identité, portfolio et signature créative — tout votre univers en un seul endroit."
      tabs={[
        { id: "profile", to: "/talent/profile", label: "Mon profil", icon: User },
        {
          id: "portfolio",
          to: "/talent/portfolio",
          label: "Portfolio",
          icon: ImageIcon,
          match: (p) => p === "/talent/portfolio" && (typeof window === "undefined" || (window.location.search || "").indexOf("tab=signature") === -1),
        },
        {
          id: "universe",
          to: "/talent/universe",
          label: "Univers créatif",
          icon: Sparkles,
          match: (p) => p === "/talent/universe" || (p === "/talent/portfolio" && typeof window !== "undefined" && (window.location.search || "").includes("tab=signature")),
        },
      ]}
      testid="profile-tabs"
    />
  );
}

export function OpportunitesTabs() {
  return (
    <SectionTabs
      eyebrow="Opportunités"
      title="Trouvez votre prochaine collaboration"
      subtitle="Collaborations ouvertes, vos candidatures et vos missions actives."
      tabs={[
        { id: "collabs", to: "/collaborations", label: "Collaborations", icon: Briefcase },
        { id: "applications", to: "/talent/applications", label: "Candidatures", icon: Inbox },
        { id: "missions", to: "/talent/missions", label: "Missions", icon: MissionIcon },
      ]}
      testid="opportunites-tabs"
    />
  );
}
